import { useCallback, useReducer } from "react";

interface MessageSourcesState {
  isExpanded: boolean;
}

type MessageSourcesAction = { type: "toggle" };

const messageSourcesInitialState: MessageSourcesState = {
  isExpanded: false,
};

const messageSourcesReducer = (
  state: MessageSourcesState,
  action: MessageSourcesAction,
): MessageSourcesState => {
  switch (action.type) {
    case "toggle":
      return { ...state, isExpanded: !state.isExpanded };
    default:
      return state;
  }
};

export const useMessageSourcesState = () => {
  const [state, dispatch] = useReducer(
    messageSourcesReducer,
    messageSourcesInitialState,
  );

  const toggleExpanded = useCallback(() => dispatch({ type: "toggle" }), []);

  return {
    isExpanded: state.isExpanded,
    toggleExpanded,
  };
};
